import {BackendApi} from "./httpClient/backendApi";
import {Event} from "../../store/models";

export const dropPlayerFromEvent = async (eventId: string, username: string): Promise<Event | null> => {
    const response = await BackendApi.getInstance().instance
        .post<{ event: Event }>(
            `/events/${eventId}/players/drop`,
            {username: username},
        );

    if (!response.data) {
        return null;
    }

    return response.data.event;
}
